import useFeatureFlag from 'src/hooks/useFeatureFlag';

export interface gTagEventProps {
  category?: string;
  label?: string;
  pro_user_type?: string;
  annual_revenue?: string;
}

/**
 * Abstraction for event call with gtag
 * @param gTagProps
 */
export const gTagEvent = (
  eventName: string,
  eventData?: gTagEventProps
): void => {
  if (typeof window === 'undefined') return;

  // Disables GA while our analyst is testing Google Tag Manager
  const disableAnalytics = useFeatureFlag('disable_analytics');
  if (disableAnalytics) return;

  const gTag = (window as any).gtag;

  if (!gTag) {
    (window as any).TrackJS &&
      (window as any).TrackJS.track('Google Analytics not loaded!');

    return;
  }

  gTag('event', eventName, eventData);
};

/**
 * Abstraction for event call with gtag with retry
 * @param gTagProps
 */
export const gTagEventWithRetry = (
  eventName: string,
  eventData?: gTagEventProps,
  remainingTries = 10
): void => {
  if (gTagAvailability()) {
    gTagEvent(eventName, eventData);
    return;
  }

  if (remainingTries <= 0) return;

  setTimeout(() => {
    gTagEventWithRetry(eventName, eventData, remainingTries - 1);
  }, 300);
};

/**
 * Checks either Google Analytics gtag function is available
 * @returns boolean
 */
export const gTagAvailability = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (!(window as any).gtag) return false;

  return true;
};
